/* Eigene Nachbesserungen am Horizon-Theme.
   Gegenstueck zu assets/eigene.css -- eingebunden in snippets/stylesheets.liquid.
   Die Datei laeuft im Seitenkopf, also bevor es den Seiteninhalt gibt. */
(function () {
  'use strict';

  /* Merker fuer das Stylesheet: nur wenn dieses Skript laeuft, duerfen die
     Pfeile bis zum Umhaengen versteckt werden. Faellt das Skript aus, bleiben
     sie sichtbar -- dann eben an ihrem urspruenglichen Platz im Bild. */
  document.documentElement.classList.add('faf-js');

  /* Die Pfeile zum Bildwechsel haengt das Theme absolut ueber das grosse Bild.
     Gewuenscht sind sie unten links und rechts neben den Miniaturbildern.
     Das <slideshow-arrows>-Element wandert dazu in die Miniaturenreihe --
     es bleibt im selben <slideshow-component>, deshalb funktionieren die
     Verweise (ref) und die Klickverdrahtung (on:click) unveraendert weiter.
     Das Aussehen macht eigene.css (display:contents auf dem Element, damit
     die beiden Knoepfe direkt in der Reihe stehen). */
  function pfeileUmhaengen() {
    var galerien = document.querySelectorAll('media-gallery.media-gallery--carousel slideshow-component');
    for (var i = 0; i < galerien.length; i++) {
      var komponente = galerien[i];
      var pfeile = komponente.querySelector('slideshow-container > slideshow-arrows');
      if (!pfeile) continue;                       // schon umgehaengt oder nicht vorhanden
      var reihe = komponente.querySelector('slideshow-controls:not(.desktop\\:hidden)');
      if (!reihe) continue;                        // Miniaturenreihe noch nicht geladen
      reihe.appendChild(pfeile);
    }
  }


  /* Der Kaufbereich soll mit dem GROSSEN Bild abschliessen, nicht mit der
     Miniaturenreihe darunter. Die Reihe ist nicht ueberall gleich hoch --
     sie haengt am Seitenverhaeltnis des Motivs (95px beim quadratischen
     Rahmen, 86px beim breiten). Ein fester Wert waere deshalb nur fuer ein
     Format richtig; ihre Hoehe wird gemessen und als Innenabstand unten an
     die rechte Spalte gegeben. Das Ausrichten selbst macht eigene.css. */
  function kaufbereichAusrichten() {
    var galerien = document.querySelectorAll('media-gallery');
    for (var i = 0; i < galerien.length; i++) {
      var galerie = galerien[i];
      var reihe = galerie.querySelector('slideshow-controls');
      var raster = galerie.closest('.product-information__grid');
      var spalte = raster ? raster.querySelector('.product-details') : null;
      if (!spalte) continue;
      var hoehe = reihe ? Math.round(reihe.getBoundingClientRect().height) : 0;
      spalte.style.setProperty('--faf-kaufen-abstand', hoehe + 'px');
    }
  }

  /* Beim Magnetic Case soll der Zeiger NICHT auf das zweite Bild umschalten.

     Seit die Cases ein zweites Bild haben -- die Aufbaugrafik -- zeigte die
     Kachel beim Darueberfahren eine auseinandergenommene Huelle statt des
     Produkts. Bei Rahmen und Downloads ist der Wechsel gewollt, dort kommt ein
     zweites Motivbild.

     Das Theme haengt den Wechsel als on:pointerenter / on:pointerleave an die
     Galerie der Kachel. Beides entfernt, und die Kachel bleibt beim ersten
     Bild; Pfeile und Schnellkauf bleiben unberuehrt.

     Erkannt werden Cases am Produktpfad: Alle 65 beginnen mit card-case-,
     kein anderes Produkt tut das. Der Sprachpraefix stoert nicht, gesucht wird
     nur nach dem Teilstueck.

     Jede Galerie wird nur einmal angefasst -- der Beobachter laeuft bei jeder
     Aenderung, und ohne Merker liefe die Schleife bei 196 Kacheln staendig
     neu. */
  function caseBildwechselAus() {
    var galerien = document.querySelectorAll('.card-gallery');
    for (var i = 0; i < galerien.length; i++) {
      var galerie = galerien[i];
      if (galerie.getAttribute('data-faf-hover-geprueft')) continue;
      galerie.setAttribute('data-faf-hover-geprueft', '1');
      if (!galerie.getAttribute('on:pointerenter')) continue;
      var karte = galerie.closest('.product-card') || galerie.parentElement;
      if (!karte || !karte.querySelector('a[href*="/products/card-case-"]')) continue;
      galerie.removeAttribute('on:pointerenter');
      galerie.removeAttribute('on:pointerleave');
    }
  }

  /* Frageabschnitte: immer nur ein Kasten offen, und beide Richtungen weich.

     Erster Versuch war der Gruppenname am <details> -- der Browser schliesst
     die anderen dann selbst. Das funktioniert, aber das Schliessen laeuft an
     jeder eigenen Regel vorbei und springt. Deshalb wird hier alles selbst
     gesteuert: Hoehe messen, Hoehe animieren, danach aufraeumen. Dadurch geht
     auch der Kasten, der beim Oeffnen eines anderen zugeht, sanft zu.

     Der Klick auf die Zusammenfassung wird in der einfangenden Phase
     abgefangen, bevor der Browser von selbst umschaltet. */

  var DAUER = 280;

  /* Aufgeraeumt wird nach fester Zeit, nicht auf transitionend.

     Erster Versuch horchte auf transitionend am Inhalt. Das Ereignis blubbert
     aber: Jeder Uebergang an einem Kindelement -- und davon gibt es im
     Textbaustein mehrere -- loeste das Aufraeumen aus, waehrend die Hoehe noch
     lief. Der Kasten ging dann ein Stueck weich zu und den Rest sprunghaft.

     Die Dauer steht fest, also reicht ein Zeitgeber. Er laeuft auch dann
     sauber ab, wenn der Browser die Animation gar nicht ausfuehrt, etwa in
     einem Tab im Hintergrund. */
  function fertig(dann) {
    setTimeout(dann, DAUER + 20);
  }

  function ruhigGewuenscht() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function aufklappen(kasten, inhalt) {
    kasten.open = true;
    if (ruhigGewuenscht()) return;
    var ziel = inhalt.scrollHeight;
    inhalt.style.transition = 'none';
    inhalt.style.height = '0px';
    inhalt.getBoundingClientRect();
    inhalt.style.transition = 'height ' + DAUER + 'ms cubic-bezier(.4, 0, .2, 1)';
    inhalt.style.height = ziel + 'px';
    fertig(function () {
      inhalt.style.height = '';
      inhalt.style.transition = '';
    });
  }

  function zuklappen(kasten, inhalt) {
    if (ruhigGewuenscht()) {
      kasten.open = false;
      return;
    }
    var start = inhalt.getBoundingClientRect().height;
    inhalt.style.transition = 'none';
    inhalt.style.height = start + 'px';
    inhalt.getBoundingClientRect();
    inhalt.style.transition = 'height ' + DAUER + 'ms cubic-bezier(.4, 0, .2, 1)';
    inhalt.style.height = '0px';
    fertig(function () {
      kasten.open = false;
      inhalt.style.height = '';
      inhalt.style.transition = '';
    });
  }

  function aufklappKlick(ereignis) {
    var zusammenfassung = ereignis.currentTarget;
    var kasten = zusammenfassung.parentElement;
    var inhalt = kasten.querySelector('.details-content');
    if (!inhalt) return;
    ereignis.preventDefault();

    if (kasten.open) {
      zuklappen(kasten, inhalt);
      return;
    }

    /* Nur innerhalb desselben Abschnitts schliessen -- zwei Frageabschnitte
       auf einer Seite sollen sich nicht gegenseitig zuklappen. */
    var gruppe = kasten.closest('[id^="shopify-section-"]') || document;
    var offene = gruppe.querySelectorAll('accordion-custom > details[open]');
    for (var i = 0; i < offene.length; i++) {
      if (offene[i] === kasten) continue;
      zuklappen(offene[i], offene[i].querySelector('.details-content'));
    }
    aufklappen(kasten, inhalt);
  }

  function aufklappGruppen() {
    var kaesten = document.querySelectorAll('accordion-custom > details');
    for (var i = 0; i < kaesten.length; i++) {
      var kasten = kaesten[i];
      if (kasten.getAttribute('data-faf-aufklapp')) continue;
      kasten.setAttribute('data-faf-aufklapp', '1');
      kasten.removeAttribute('name');
      var zusammenfassung = kasten.querySelector('summary');
      if (zusammenfassung) zusammenfassung.addEventListener('click', aufklappKlick, true);
    }
  }

  var geplant = false;
  function planen() {
    if (geplant) return;
    geplant = true;
    queueMicrotask(function () {
      geplant = false;
      pfeileUmhaengen();
      kaufbereichAusrichten();
      caseBildwechselAus();
      aufklappGruppen();
    });
  }

  /* Der Beobachter laeuft ab sofort auf dem ganzen Dokument. Dadurch wandern
     die Pfeile schon waehrend des Aufbaus an ihren Platz, sobald die
     Miniaturenreihe da ist -- vorher warteten sie bis zum fertigen Dokument
     und sprangen sichtbar nach unten. Er bleibt danach aktiv, weil das Theme
     die Galerie beim Farbwechsel neu aufbaut. */
  if (window.MutationObserver) {
    new MutationObserver(planen).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      pfeileUmhaengen();
      caseBildwechselAus();
      aufklappGruppen();
    });
  } else {
    pfeileUmhaengen();
    caseBildwechselAus();
    aufklappGruppen();
  }
})();

/* --- Suche ohne Umweg ueber eine eigene Suchseite -------------------------

   Gewuenscht: Wer in der Sortimentsleiste oder oben in der Lupe sucht, bleibt
   auf "Alle Produkte" -- es soll keine fremd aussehende Suchseite aufgehen.

   Shopify findet Produkte nur unter /search; eine Kollektionsseite hat in
   Liquid keinen Zugriff auf die Suche. Deshalb holt dieses Skript die fertig
   gerenderte Trefferliste ueber die Section-Rendering-API
   (/search?q=...&section_id=main) und setzt die Produktkacheln daraus in das
   Raster von "Alle Produkte". Die Adresse bleibt /collections/all?q=...

   Damit die Kacheln dort genauso aussehen wie die eigenen, tragen die
   Kartenbausteine in templates/search.json dieselben Kennungen und
   Einstellungen wie in templates/collection.json -- Shopify leitet die
   Klassennamen daraus ab, gleiche Eingabe also gleiche Klassen.

   Ohne JavaScript senden beide Formulare weiter an /search. Dann ist die
   Suchseite zwar sichtbar, liefert aber das Richtige -- deshalb bleibt in den
   Formularen action="/search" stehen. */
(function () {
  'use strict';

  var MAX_SEITEN = 8;       /* Sicherheitsgrenze; eine Seite sind 24 Treffer */

  var wurzel = document.documentElement;

  /* Sind wir auf "Alle Produkte"? Der Teil vor /collections/all ist das
     Sprachpraefix: leer auf der deutschen, /en auf der englischen Seite.
     Daraus entsteht die passende Adresse der Suche. */
  /* Beide Handles: 'alle-produkte' ist die eigene Kollektion (nach Datum
     sortiert), 'all' die von Shopify erzeugte Liste. Wer auf der alten
     Adresse landet, soll die Suche trotzdem bekommen. */
  var teile = location.pathname.match(/^(.*)\/collections\/(?:alle-produkte|all)\/?$/);
  var istAlle = !!teile;
  var sprachbasis = teile ? teile[1] : '';

  function begriffAusAdresse() {
    try {
      return (new URLSearchParams(location.search).get('q') || '').trim();
    } catch (e) {
      return '';
    }
  }

  var start = istAlle ? begriffAusAdresse() : '';
  var laufend = start;

  /* Das Raster wird sofort verborgen, noch bevor der Seiteninhalt gelesen ist.
     Sonst blitzt beim Aufruf mit ?q=... erst das ganze Sortiment auf. */
  if (start) wurzel.classList.add('faf-suche-laedt');

  /* --- Texte ---------------------------------------------------------------
     Zweisprachig, geliefert von sections/faf-katnav.liquid als data-Attribute.
     Die deutschen Fassungen stehen hier nur als Notnagel. */
  function text(name, ersatz) {
    var quelle = document.querySelector('[data-faf-t-' + name + ']');
    var wert = quelle ? quelle.getAttribute('data-faf-t-' + name) : '';
    return wert || ersatz;
  }

  function adresseAlleProdukte() {
    var quelle = document.querySelector('[data-faf-alle]');
    if (quelle) return quelle.getAttribute('data-faf-alle');
    return istAlle ? location.pathname : '/collections/alle-produkte';
  }

  function adresseSuche() {
    var quelle = document.querySelector('[data-faf-suchziel]');
    if (quelle) return quelle.getAttribute('data-faf-suchziel');
    return sprachbasis + '/search';
  }

  /* --- Treffer holen ------------------------------------------------------ */

  function seiteHolen(q, nr, kennung) {
    var adresse = new URL(adresseSuche(), location.origin);
    adresse.searchParams.set('q', q);
    adresse.searchParams.set('type', 'product');
    /* Wortanfaenge zaehlen mit -- genau wie in der Vorschlagsliste der Lupe.
       Ohne das fand die Liste zu "charm" etwas, nach der Eingabetaste dann
       nichts mehr. */
    adresse.searchParams.set('options[prefix]', 'last');
    if (nr > 1) adresse.searchParams.set('page', String(nr));
    /* Die erste Seite kommt als ganzes Dokument. Nur daraus laesst sich die
       Kennung des Trefferabschnitts ablesen: In JSON-Vorlagen heisst er nicht
       "main", sondern traegt die Nummer der Vorlage davor
       (template--31497801007447__main). Die kann man nicht raten, und ohne
       sie antwortet Shopify mit einer Fehlerseite. Ab Seite 2 wird damit nur
       noch der Abschnitt geholt statt der ganzen Seite. */
    if (kennung) adresse.searchParams.set('section_id', kennung);
    return fetch(adresse.toString(), { credentials: 'same-origin' })
      .then(function (antwort) {
        if (!antwort.ok) throw new Error('Suche: ' + antwort.status);
        return antwort.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function kachelnAus(dokument) {
    var liste = dokument.querySelector('#ResultsList ul.product-grid');
    if (!liste) return [];
    /* Nur die Kacheln. Das Theme legt in jede Rasterseite zusaetzlich ein
       <script>-Element; als Kind des <ul> wuerde es mitgezaehlt und die
       gemeldete Trefferzahl waere je Seite um eins zu hoch. */
    return Array.prototype.slice.call(liste.querySelectorAll(':scope > li'));
  }

  /* --- Aussieben ---------------------------------------------------------
     Shopifys Suche antwortet semantisch: "lugia" brachte 46 Treffer, davon
     waren 3 wirklich Lugia; "zekrom" 112, also fast das ganze Sortiment.
     Belegt ist es mit "wasserpokemon" -- das Wort steht nirgends in den Daten
     und liefert trotzdem Lapras und Wailord zuerst. An der Abfrage laesst sich
     das nicht abstellen: options[fields]=title aendert die Zahl nicht, und die
     Vorschlagsliste der Lupe streut genauso. Gesiebt wird deshalb hier.

     Gesucht wird in Titel UND Schlagwoertern. Nur im Titel reichte nicht: Auf
     der deutschen Seite heisst Charmander im Titel "Glumanda" -- beide Namen
     stehen ausschliesslich in den Schlagwoertern. Ohne sie faende die deutsche
     Seite die englischen Namen nicht mehr, und genau das soll sie koennen.

     Die Schlagwoerter reisen in einem versteckten Element je Kachel mit; das
     legt templates/search.json an. Traegt keine einzige Kachel die Kennzeichen,
     wird nicht gesiebt -- lieber zu viele Treffer als versehentlich keine. */
  function schluessel(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') /* Akzente weg: Pokémon wird pokemon */
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function passt(kachel, woerter) {
    var marke = kachel.querySelector('[data-faf-suchtext]');
    if (!marke) return true;
    var text = ' ' + schluessel(marke.getAttribute('data-faf-suchtext')) + ' ';
    for (var i = 0; i < woerter.length; i++) {
      /* Wortanfang genuegt, damit "charm" Charmander findet -- so wie es die
         Vorschlagsliste beim Tippen auch tut. */
      if (text.indexOf(' ' + woerter[i]) === -1) return false;
    }
    return true;
  }

  function aussieben(gefunden, q) {
    var woerter = schluessel(q).split(' ');
    var echte = [];
    for (var w = 0; w < woerter.length; w++) {
      if (woerter[w]) echte.push(woerter[w]);
    }
    if (!echte.length) return gefunden;

    var markiert = 0;
    for (var i = 0; i < gefunden.length; i++) {
      if (gefunden[i].querySelector('[data-faf-suchtext]')) markiert++;
    }
    if (!markiert) return gefunden;

    var behalten = [];
    for (var k = 0; k < gefunden.length; k++) {
      if (passt(gefunden[k], echte)) behalten.push(gefunden[k]);
    }
    return behalten;
  }

  function kachelnHolen(q) {
    return seiteHolen(q, 1).then(function (dokument) {
      /* Ohne Treffer zeigt der Abschnitt ersatzweise eine ganze Kollektion mit
         eigener Ueberschrift. Daran ist der Fall erkennbar -- sonst wuerde das
         gesamte Sortiment als "Treffer" ausgegeben. */
      if (
        dokument.querySelector('.main-collection-grid__title') ||
        dokument.querySelector('.main-collection-grid__empty')
      ) {
        return [];
      }

      var gefunden = kachelnAus(dokument);
      var liste = dokument.querySelector('#ResultsList ul.product-grid');
      var letzte = liste ? parseInt(liste.getAttribute('data-last-page') || '1', 10) : 1;
      if (!letzte || letzte < 2) return aussieben(gefunden, q);

      /* Alle weiteren Seiten gleich mitholen. Das eingebaute Nachladen beim
         Scrollen wuerde sonst die Adresse der Kollektionsseite verwenden und
         das ganze Sortiment an die Treffer haengen. */
      var behaelter = dokument.querySelector('results-list[section-id]');
      var kennung = behaelter ? behaelter.getAttribute('section-id') : '';
      var offen = [];
      for (var nr = 2; nr <= Math.min(letzte, MAX_SEITEN); nr++) offen.push(seiteHolen(q, nr, kennung));
      return Promise.all(offen).then(function (weitere) {
        for (var i = 0; i < weitere.length; i++) gefunden = gefunden.concat(kachelnAus(weitere[i]));
        return aussieben(gefunden, q);
      });
    });
  }

  /* --- Anzeigen ----------------------------------------------------------- */

  function statuszeile() {
    var vorhanden = document.querySelector('.faf-suchstatus');
    if (vorhanden) return vorhanden;
    var raster = document.getElementById('ResultsList');
    if (!raster || !raster.parentNode) return null;
    var zeile = document.createElement('p');
    zeile.className = 'faf-suchstatus';
    zeile.setAttribute('aria-live', 'polite');
    raster.parentNode.insertBefore(zeile, raster);
    return zeile;
  }

  function feldFuellen(q) {
    var felder = document.querySelectorAll('.faf-katnav__suchfeld');
    for (var i = 0; i < felder.length; i++) felder[i].value = q;
  }

  function anzeigen(q, gefunden) {
    var liste = document.querySelector('#ResultsList ul.product-grid');
    wurzel.classList.remove('faf-suche-laedt', 'faf-suche-arbeitet');
    if (!liste) return;

    while (liste.firstChild) liste.removeChild(liste.firstChild);
    for (var i = 0; i < gefunden.length; i++) liste.appendChild(gefunden[i]);

    /* Nachladen beim Scrollen abschalten: Die beiden Marken loesen es aus,
       sobald sie in Sicht kommen. Aus dem Dokument entfernt kann das nicht
       mehr passieren. */
    liste.setAttribute('data-last-page', '1');
    var marken = document.querySelectorAll(
      '#ResultsList [ref="viewMoreNext"], #ResultsList [ref="viewMorePrevious"]'
    );
    for (var m = 0; m < marken.length; m++) marken[m].remove();
    var behaelter = liste.closest('results-list');
    if (behaelter) behaelter.setAttribute('infinite-scroll', 'false');

    /* Die Sortierung greift auf die Kollektion, nicht auf die Treffer. Waehrend
       eine Suche angezeigt wird, waere sie ein Knopf ohne Wirkung -- also weg
       damit. Beim Zuruecksetzen laedt die Seite neu und er ist wieder da. */
    var sortierung = document.querySelector('.faf-sortierung');
    if (sortierung) sortierung.hidden = true;

    var zeile = statuszeile();
    if (!zeile) return;
    var vorlage = gefunden.length
      ? text('treffer', '%z Treffer für „%s“')
      : text('kein', 'Keine Treffer für „%s“');
    while (zeile.firstChild) zeile.removeChild(zeile.firstChild);
    var wort = document.createElement('span');
    wort.className = 'faf-suchstatus__text';
    wort.textContent = vorlage.replace('%z', String(gefunden.length)).replace('%s', q);
    var weg = document.createElement('a');
    weg.className = 'faf-suchstatus__weg';
    weg.href = adresseAlleProdukte();
    weg.textContent = text('weg', 'Suche zurücksetzen');
    zeile.appendChild(wort);
    zeile.appendChild(weg);

    /* Erst jetzt nach oben, nicht schon beim Absenden: Waehrend die Treffer
       noch geholt werden, steht das alte Raster da, und der Browser haelt die
       sichtbare Stelle fest (Scroll-Anchoring) -- ein sanftes Rollen wurde
       dabei wieder zurueckgezogen. Nach dem Austausch sitzt die Seite fest. */
    nachObenRollen();
  }

  function fehlschlag(q) {
    wurzel.classList.remove('faf-suche-laedt', 'faf-suche-arbeitet');
    var zeile = statuszeile();
    if (!zeile) return;
    while (zeile.firstChild) zeile.removeChild(zeile.firstChild);
    var wort = document.createElement('span');
    wort.className = 'faf-suchstatus__text';
    wort.textContent = text('fehler', 'Die Suche ist gerade nicht erreichbar.');
    var hin = document.createElement('a');
    hin.className = 'faf-suchstatus__weg';
    hin.href = adresseSuche() + '?q=' + encodeURIComponent(q);
    hin.textContent = text('ersatz', 'Trotzdem suchen');
    zeile.appendChild(wort);
    zeile.appendChild(hin);
  }

  function wennRasterDa(tun) {
    if (document.getElementById('ResultsList')) {
      tun();
    } else if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tun, { once: true });
    } else {
      tun();
    }
  }

  /* Das Suchfenster der Lupe sperrt das Scrollen der Seite. Freigegeben wird
     die Sperre nur im Schliessweg des Themes (dialog.js: unlockScroll steckt in
     closeDialog, nicht in einem Handler am close-Ereignis). Ein einfaches
     dialog.close() liesse die Seite unscrollbar zurueck -- deshalb immer ueber
     die Komponente. Sie gibt ein Versprechen zurueck und stellt danach die
     vorige Scrollposition wieder her; die eigene Suche laeuft deshalb erst
     danach, sonst wuerde sie zurueckgescrollt. */
  function fensterSchliessen(element) {
    var komponente = element && element.closest ? element.closest('dialog-component') : null;
    if (!komponente || typeof komponente.closeDialog !== 'function') return Promise.resolve();
    try {
      return Promise.resolve(komponente.closeDialog());
    } catch (e) {
      return Promise.resolve();
    }
  }

  /* Gerollt wird in diesem Theme nicht das Fenster, sondern .page-wrapper --
     das Fenster selbst steht fest, der Behaelter traegt overflow: auto. Ein
     window.scrollTo bliebe wirkungslos, und wer mitten auf der Seite sucht,
     saehe die neuen Treffer nicht. */
  function nachObenRollen() {
    var wanne = document.querySelector('.page-wrapper');
    if (wanne && wanne.scrollHeight > wanne.clientHeight + 1) {
      /* Der Behaelter traegt scroll-behavior: smooth. Jedes Rollen von Hand
         laeuft dann weich -- und wird unterwegs abgebrochen; gemessen kam die
         Seite keinen Pixel weit, weder ueber scrollTo noch ueber scrollTop
         noch ueber scrollIntoView. Fuer diesen einen Sprung wird die Weichheit
         deshalb kurz abgeschaltet und gleich wieder zurueckgegeben. */
      var vorher = wanne.style.scrollBehavior;
      wanne.style.scrollBehavior = 'auto';
      wanne.scrollTop = 0;
      wanne.style.scrollBehavior = vorher;
      return;
    }
    window.scrollTo(0, 0);
  }

  function neueSuche(q) {
    laufend = q;
    feldFuellen(q);
    wurzel.classList.add('faf-suche-arbeitet');
    var zeile = statuszeile();
    if (zeile) zeile.textContent = text('laedt', 'Suche läuft …');
    history.pushState({ faf: q }, '', adresseAlleProdukte() + '?q=' + encodeURIComponent(q));
    kachelnHolen(q).then(
      function (gefunden) {
        anzeigen(q, gefunden);
      },
      function () {
        fehlschlag(q);
      }
    );
  }

  /* Aufruf mit ?q=... -- die Anfrage laeuft schon, waehrend die Seite noch
     gelesen wird. */
  if (start) {
    var versprechen = kachelnHolen(start);
    wennRasterDa(function () {
      feldFuellen(start);
      var zeile = statuszeile();
      if (zeile && !zeile.firstChild) zeile.textContent = text('laedt', 'Suche läuft …');
      versprechen.then(
        function (gefunden) {
          anzeigen(start, gefunden);
        },
        function () {
          fehlschlag(start);
        }
      );
    });
  }

  /* --- Formulare abfangen ------------------------------------------------- */

  document.addEventListener('submit', function (ereignis) {
    var formular = ereignis.target;
    if (!(formular instanceof HTMLFormElement)) return;
    var istLeiste = formular.classList.contains('faf-katnav__suche');
    var istKopf = formular.classList.contains('predictive-search-form');
    if (!istLeiste && !istKopf) return;

    var feld = formular.querySelector('input[name="q"]');
    var q = feld ? feld.value.trim() : '';
    ereignis.preventDefault();

    if (!q) {
      location.assign(adresseAlleProdukte());
      return;
    }
    if (!istAlle) {
      location.assign(adresseAlleProdukte() + '?q=' + encodeURIComponent(q));
      return;
    }
    fensterSchliessen(formular).then(function () {
      neueSuche(q);
    });
  });

  /* Die Lupe oben: Das Theme schickt bei der Eingabetaste selbst zur Suchseite
     (predictive-search.js setzt window.location). Das laesst sich nur vorher
     abfangen -- deshalb hier in der einfangenden Phase, bevor der eigene
     Handler des Bausteins dran ist.

     Zwei Faelle bleiben dem Theme: ein einziger Treffer (springt direkt zum
     Produkt) und ein mit den Pfeiltasten ausgewaehlter Vorschlag. */
  document.addEventListener(
    'keydown',
    function (ereignis) {
      if (ereignis.key !== 'Enter' || ereignis.defaultPrevented) return;
      var feld = ereignis.target;
      if (!feld || !feld.closest || feld.name !== 'q') return;
      var baustein = feld.closest('predictive-search-component');
      if (!baustein) return;
      if (baustein.querySelector('[data-single-result-url]')) return;
      if (baustein.querySelector('[aria-selected="true"]')) return;

      var q = (feld.value || '').trim();
      if (!q) return;

      ereignis.preventDefault();
      ereignis.stopImmediatePropagation();

      if (!istAlle) {
        location.assign(adresseAlleProdukte() + '?q=' + encodeURIComponent(q));
        return;
      }
      fensterSchliessen(baustein).then(function () {
        neueSuche(q);
      });
    },
    true
  );

  /* Zurueck-Taste: Die Trefferliste steckt nicht in der Verlaufsposition.
     Nur neu laden, wenn sich der Suchbegriff wirklich unterscheidet -- das
     Nachladen beim Scrollen schreibt ebenfalls in den Verlauf. */
  window.addEventListener('popstate', function () {
    if (!istAlle) return;
    if (begriffAusAdresse() === laufend) return;
    location.reload();
  });
})();
